import { render, staticRenderFns } from "./Collapse.vue?vue&type=template&id=7ebcd4d0&scoped=true&lang=pug&"
import script from "./Collapse.vue?vue&type=script&lang=ts&"
export * from "./Collapse.vue?vue&type=script&lang=ts&"
import style0 from "./Collapse.vue?vue&type=style&index=0&id=7ebcd4d0&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ebcd4d0",
  null
  
)

export default component.exports